import React from "react";
import FeedbackButtons from "./FeedbackButtons";
import CollapsibleCSVTable from "./CollapsibleCSVTable";

const FindingsPanel = ({ data, setCommentModalData, traceID }) => {
  if (!data?.findings_display?.length) return null;

  return (
    <div className="findings-column">
      <div className="header findings-header">Automated Investigation Engine Findings</div>
      {data.findings_display.map((finding, idx) => (
        <div className="finding-section" key={idx}>
          <div className="finding-title">{finding.title}</div>
          {finding.subtitle && <div className="finding-subtitle">{finding.subtitle}</div>}
          <div className="finding-text">{finding.text}</div>
          <FeedbackButtons
            traceID={traceID}
            sectionData={{ module: finding.title, text: finding.text }}
            setCommentModalData={setCommentModalData}
            agent="wgedr"
          />
          {finding.data && (
            <div className="finding-data-table wgedr-finding-data-table">
              <CollapsibleCSVTable data={finding.data} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FindingsPanel;
